import { render } from "./NoPosts.vue?vue&type=template&id=fd7a4d52&scoped=true"
import script from "./NoPosts.vue?vue&type=script&lang=js"
export * from "./NoPosts.vue?vue&type=script&lang=js"

import "./NoPosts.vue?vue&type=style&index=0&id=fd7a4d52&lang=scss&scoped=true"

import exportComponent from "/Users/skynet/Documents/Sites Safe OK MAIS PEUT ETRE PAS A JOUR/Safe_Sites_Modifs/SAFE_ORTHO/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd7a4d52"]])

export default __exports__